// Simple localStorage-backed journal for reflections on verses.
// Each entry: { id, verse: {text, reference, translation, category}, entry, createdAt }

const KEY = "lifted_daily.journal.v1";

export const MAX_ENTRY_CHARS = 240;

const safeParse = (raw) => {
  try {
    const v = JSON.parse(raw);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const getEntries = () => {
  if (typeof window === "undefined") return [];
  return safeParse(window.localStorage.getItem(KEY));
};

export const addEntry = ({ verse, entry }) => {
  const items = getEntries();
  const record = {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    verse: {
      text: verse.text,
      reference: verse.reference,
      translation: verse.translation,
      category: verse.category,
    },
    entry: (entry || "").trim().slice(0, MAX_ENTRY_CHARS),
    createdAt: new Date().toISOString(),
  };
  const next = [record, ...items];
  window.localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};

export const removeEntry = (id) => {
  const items = getEntries();
  const next = items.filter((e) => e.id !== id);
  window.localStorage.setItem(KEY, JSON.stringify(next));
  return next;
};

// A small pool of gentle prompts — picked based on the verse's category.
const PROMPTS_BY_CATEGORY = {
  peace: "Where is peace trying to find you today?",
  anxiety: "What is pressing on you that you could hand over tonight?",
  faith: "Where is God inviting you to trust Him right now?",
  hope: "What might you be hoping for in this season?",
  love: "Who does this verse bring to mind — including yourself?",
  strength: "Where do you need to borrow His strength today?",
  gratitude: "What small thing do you want to name with thanks?",
  guidance: "What next step might God be lighting for you?",
  joy: "Where has gladness surprised you lately?",
  forgiveness: "Is there something you can release tonight?",
  comfort: "What part of you needs to be comforted right now?",
  faithfulness: "Where have you seen Him keep His word to you?",
  identity: "What part of who you are is God reminding you of?",
  perseverance: "What are you still walking through — and still walking?",
  worship: "What rises in you when you read this tonight?",
  prayer: "What would you like to bring to Him, in your own words?",
  surrender: "What are you holding a little too tightly?",
  kindness: "Who in your life could you love a little more gently?",
  humility: "Where might honest humility help you today?",
  wisdom: "What decision could you invite God into right now?",
  healing: "Where in you is He still tending and mending?",
  patience: "What are you being asked to wait on — and how is it shaping you?",
  courage: "Where do you need courage this week?",
  purpose: "What feels like your ‘such a time as this’ right now?",
};

const DEFAULT_PROMPT = "Where does this verse meet you tonight?";

export const promptForVerse = (verse) => {
  if (!verse) return DEFAULT_PROMPT;
  return PROMPTS_BY_CATEGORY[verse.category] || DEFAULT_PROMPT;
};
